export function Subheader({
  subHeader,
  tertiaryHeader,
}: {
  subHeader: string;
  tertiaryHeader?: string;
}) {
  return (
    <div className='flex flex-col space-y-1'>
      <h2 className='font-inter text-lg leading-7 font-semibold text-gray-900'>
        {subHeader}
      </h2>
      {tertiaryHeader && (
        <h3 className='font-inter text-base leading-6 font-normal text-gray-500'>
          {tertiaryHeader}
        </h3>
      )}
    </div>
  );
}
